import { useResultPromiseInitializer, useResultPromiseRef, useResultPromiseResolvers } from 'forms-ai-lib/internal/providers/ResultPromiseContext';
import { useDispatch, useSelector } from 'forms-ai-lib/internal/hooks/redux';
import { closeModal, openModal } from 'forms-ai-lib/internal/reducers/config';
import { selectIsOpen } from 'forms-ai-lib/internal/selectors/config';
import { useStableFunction } from 'forms-ai-lib/internal/hooks/useStableFunction';
export const useFormAIWizard = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(selectIsOpen);
  const resultPromiseRef = useResultPromiseRef();
  const initializeResultPromise = useResultPromiseInitializer();
  const {
    queueResolve
  } = useResultPromiseResolvers();
  const openFormAIWizard = useStableFunction(() => {
    const promise = initializeResultPromise();
    dispatch(openModal());
    return promise;
  });
  const closeFormAIWizard = useStableFunction(() => {
    if (isOpen) {
      dispatch(closeModal());
    }
  });
  const forceCloseFormAIWizard = useStableFunction(() => {
    if (!isOpen || resultPromiseRef.current === null) {
      return Promise.resolve({
        cancelled: true
      });
    }
    queueResolve({
      cancelled: true
    });
    dispatch(closeModal());
    return resultPromiseRef.current.promise;
  });
  return {
    isOpen,
    closeFormAIWizard,
    openFormAIWizard,
    forceCloseFormAIWizard
  };
};